import { React, useState } from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import { Alerta } from '../../components/alerta';
import DayDatePicker from '../../components/dayDatePicker';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { formatIsoDate } from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';

const LogsMonitoramento = () => {
    const [dateTime, setdateTime] = useState(null);
    const [inversor, setInversor] = useState(false);
    const [rele, setRele] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitLogsMonitoramento (e) {
        e.preventDefault();
        setIsSubmit(true);

        if (!inversor && !rele) {
            alert('Selecione pelo menos uma opção!!');
            return;
        }

        let data = '';
        if (dateTime) {
            data = formatIsoDate(dateTime);
        }

        const body = JSON.stringify({ data, inversor, rele });

        const response = await fetchFlask('getLogsMonitoramento', body);
        handleAlerta(response);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setdateTime(null);
            setInversor(false);
            setRele(false);
        }
        setIsSubmit(false);
    };

    function handleAlerta (response) {
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
    }

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>Obter Logs</PageHeader>

            <form action='' method='POST' id='formLogsMonitoramento' onSubmit={submitLogsMonitoramento}>
                <Box className='row'>
                    <Box className='column'>
                        <FormControl sx={{ marginTop: '20px' }} >
                            <DayDatePicker
                                id='data'
                                label='Data'
                                minDate={new Date('2025-01-02')}
                                value={dateTime}
                                onChange={setdateTime}
                            />
                        </FormControl >

                        <FormControl sx={{ display: 'block', marginTop: '20px' }} >
                            <FormControlLabel control={
                                <Checkbox
                                    onChange={(e) => setInversor(e.target.checked)}
                                />
                                }
                                label="Inversor"
                            />
                        </FormControl>

                        <FormControl sx={{ display: 'block', marginTop: '20px' }} >
                            <FormControlLabel control={
                                <Checkbox
                                    onChange={(e) => setRele(e.target.checked)}
                                />
                                }
                                label="Rele"
                            />
                        </FormControl>

                        <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                            <SubmitButton isSubmit={isSubmit}>Obter Logs</SubmitButton>
                        </FormControl>
                    </Box>
                </Box>
            </form>
        </Box>
    );
};

export default LogsMonitoramento;
